import { always } from 'ramda';

import stubUndefined from './stubUndefined';

/**
 * A function that performs no operations.
 *
 * @func noop
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.0.0|v1.0.0}
 * @category Function
 * @sig ... -> undefined
 * @return {undefined}
 * @example
 *
 * RA.noop(); //=> undefined
 * RA.noop(1, 2, 3); //=> undefined
 */
var noop = /*#__PURE__*/always( /*#__PURE__*/stubUndefined());

export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/noop.js
// module id = 762
// module chunks = 0